// // Use $ instead of jQuery without replacing global $
(function ($) {
  /*
   * footer
   */
  $(document).ready(function () {
    $('.footer .footer-menu').click(function (e) {
      e.stopPropagation();
      e.preventDefault();
      $('.footer .menu').toggleClass("active");
      $('.footer .footer-menu').toggleClass("active");
    });
    $(document).mouseup(function (e) {
      var container = $(".footer");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        e.preventDefault();
        $('.footer .menu').removeClass("active");
        $('.footer .footer-menu').removeClass("active");
      }
    });
    $('body .footer .content-wrap .search-icon').click(function (e) {

      if ($('body .footer .search-outer').hasClass('expanded')) {

      } else {
        e.preventDefault();
        $('body .footer .search-outer').toggleClass('expanded');
      }

    });
    $('body .footer .search-outer .cross-outer').click(function () {
      if ($('body .footer .search-outer').hasClass('expanded')) {
        $('body .footer .search-outer').removeClass('expanded');
      }
    });
  });

  $(document).click(function (e) {

    // e.preventDefault();
    $('.footer .menu').removeClass("active");
    $('.footer .footer-menu').removeClass("active");
  });
})(jQuery);